import { render, staticRenderFns } from "./TeamsCorrect.vue?vue&type=template&id=124596c2&scoped=true&"
import script from "./TeamsCorrect.vue?vue&type=script&lang=ts&"
export * from "./TeamsCorrect.vue?vue&type=script&lang=ts&"
import style0 from "./TeamsCorrect.vue?vue&type=style&index=0&id=124596c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124596c2",
  null
  
)

export default component.exports